import Packages from './Packages';
import Circles from './Circles';

export default function Order({ order, onExpand, isExpanded }) {
  function handleHeaderClick() {
    if (onExpand) {
      onExpand(isExpanded ? null : order.id);
    }
  }

  return (
    <li className={isExpanded ? 'expanded' : null}>
      <button
        type="button"
        className="order-header"
        onClick={handleHeaderClick}
        aria-expanded={isExpanded}
        aria-controls={`order-packages-${order.id}`}
      >
        <div className="left-side">
          <h3>{order.title}</h3>
          <span className="timestamp">
            {order.created}&nbsp;&middot;&nbsp;{order.direction}
          </span>
        </div>
        <div className="right-side">
          <Circles order={order} />
          <div className="labels">
            <span className="label label-neutral label-tiny">
              {order.price}
            </span>
            <span className="label label-inverse label-tiny">
              {order.weight}
            </span>
          </div>
        </div>
      </button>
      {isExpanded ? (
        <Packages id={`order-packages-${order.id}`} order={order} />
      ) : null}
    </li>
  );
}
